import React, {useState} from 'react';
import {Button} from 'react-admin';
import {showErrorNotify, showSuccessNotify} from "../../components";
import Swal from "sweetalert2";
import {CircularProgress} from "@material-ui/core";
import {downloadFilePut} from "../../components/FileDownload";
import env from "../../env";

const EnrollmentSyncButton = () => {
    const [isLoading, setIsLoading] = useState(false)

    function onSubmit() {
        Swal.fire({
            title: 'Xác nhận',
            text: `Dữ liệu học sinh hiện tại sẽ được cập nhật theo danh sách lớp của dữ liệu edu, bạn có muốn tiếp tục?`,
            type: "warning",
            showCloseButton: true,
            showCancelButton: true,
            cancelButtonColor: '#d33',
            focusConfirm: false,
        }).then(async (result) => {
            if (result.value) {
                setIsLoading(true)
                downloadFilePut(`${env.baseURL}/api/eduDatas/syncEnrollment`, 'ket_qua_dong_bo_ds_hoc_sinh.xlsx', null)
                    .then(() => {
                        showSuccessNotify("Vui lòng kiểm tra file kết quả");
                        setIsLoading(false)
                    })
                    .catch(() => {
                        showErrorNotify("Có lỗi xảy ra, vui lòng thử lại hoặc liên hệ quản trị viên");
                        setIsLoading(false)
                    })
            }
        })
    }

    return (<>
            {isLoading && <CircularProgress style={{marginRight: 10}} color="secondary"/>}
            <Button variant="outlined" label="Đồng bộ ds lớp" disabled={isLoading} onClick={onSubmit}/>
        </>
    );
}
export default EnrollmentSyncButton;